import React, { useState } from "react";
import "../../Styles/AdminPressForm.css";

function AdminPressForm() {
  const [preview, setPreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Add Press Photo</h2>
        <button className="adminpress12-back-btn" onClick={() => window.history.back()}>
          Back
        </button>
      </div>

      <form className="adminpress12-form">
        <div className="adminpress12-form-row">
          <div className="adminpress12-form-group">
            <label>Press Title</label>
            <input type="text" placeholder="Enter Press Title" required />
          </div>

          <div className="adminpress12-form-group">
            <label>Status</label>
            <select defaultValue="Active">
              <option>Active</option>
              <option>Inactive</option>
            </select>
          </div>
        </div>

        <div className="adminpress12-form-row">
          <div className="adminpress12-form-group">
            <label>Upload Photo</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              required
            />
          </div>

          <div className="adminpress12-form-group">
            <label>Date</label>
            <input type="date" name="dateAdded" required />
          </div>
        </div>

        {preview && (
          <div className="adminpress12-preview-box">
            <img src={preview} alt="Preview" className="adminpress12-preview-img" />
          </div>
        )}

        <div className="adminpress12-form-group">
          <label>Caption / Description</label>
          <textarea rows="4" placeholder="Optional Caption"></textarea>
        </div>

        <button className="adminpress12-sub-btn" type="submit">
          Submit Press Photo
        </button>
      </form>
    </div>
  );
}

export default AdminPressForm;